export function getFilteredAppsList(_list, filter, installed_app_id) {
  let list =
    filter === 'directory' || filter === null
      ? _list
      : _list.filter(item => item.companies?.[0]?.status === 'granted')

  return installed_app_id && filter === 'directory'
    ? [list.find(item => item.id === installed_app_id)]
    : list
}
